import { useContext } from "react"
import { func, string } from "prop-types"
import { useNavigate } from "react-router-dom"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import { useSearchParams } from "source/myChurchCenter/hooks/useSearchParams"
import { useHouseholds } from "source/myChurchCenter/ProfileAndHousehold/hooks/useHouseholds"
import { useSession } from "source/shared/hooks/useSession"
import { useProfile } from "../ProfileAndHousehold/hooks/useProfile"
import { WebBootContext } from "source/publishing/WebBoot"

RemoveFromHouseholdButton.propTypes = {
  personId: string.isRequired,
  onRemove: func,
}

export function RemoveFromHouseholdButton({ personId, onRemove }) {
  const {
    data: { id: currentPersonId },
  } = useSession(true)
  const {
    abilities: {
      people: {
        add_or_remove_household_members: addOrRemoveHouseholdMembersEnabled,
      },
    },
  } = useContext(WebBootContext)
  const navigate = useNavigate()
  const [searchParams, _setSearchParams] = useSearchParams()
  const { data: households, refetch: reloadHouseholds } = useHouseholds()
  const { data: profile } = useProfile(personId)

  const { data: currentUserProfile } = useProfile(currentPersonId)
  const currentUserIsChild = currentUserProfile.data.attributes.child
  const canRemoveProfileFromHousehold =
    !currentUserIsChild && currentPersonId !== personId

  const household =
    households.find(
      (household) => household.id === searchParams.get("household"),
    ) || households[0]
  const householdId = household?.id
  const householdMemberId = household?.householdMembers.find(
    (member) => member.personId === personId,
  )?.householdMemberId

  function removeHouseholdMember() {
    let returnPath = `/me/profile-and-household?profile=${currentPersonId}`
    if (searchParams.get("household")) {
      returnPath += `&household=${searchParams.get("household")}`
    }

    if (
      confirm(
        `Are you sure you want to remove ${profile?.data.attributes?.name || "this person"} from your household?`,
      )
    ) {
      sessionApiClient
        .del(
          `/people/v2/people/${currentPersonId}/households/${householdId}/household_members/${householdMemberId}`,
        )
        .then(() => {
          reloadHouseholds()
          navigate(returnPath, { replace: true })
          onRemove?.()
        })
        .catch(() =>
          alert("An error occured. Please reload the page and try again"),
        )
    }
  }

  // Only show the button if the current person is viewing someone else's profile
  // and they have permission to remove household members
  if (!canRemoveProfileFromHousehold || !addOrRemoveHouseholdMembersEnabled) {
    return null
  }

  return (
    <div className="ta-c">
      <button
        className="btn secondary-btn destroy-btn"
        onClick={removeHouseholdMember}
      >
        Remove from household
      </button>
    </div>
  )
}
